import { injectIntl } from "react-intl";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from "@mui/material";
import { ArrowForwardIosOutlined as ArrowForwardIosOutlinedIcon } from "@mui/icons-material";
import { ENTER, WELCOME_INFO, WELCOME_INFO_2, WELCOME_INFO_3, WELCOME_TITLE } from "../../modules/language";
import { PSTrackerBiancoIcon } from "../../styles/images";
import { getMessageString } from "../../utility";
import { Link } from "react-router-dom";
import { PATH_FAQ } from "../../path";

export const WelcomePage = injectIntl(({ intl, modalOpen, onEnter }) => (
  <Dialog open={modalOpen} className="welcomePageModalAlert" aria-labelledby="welcomePageDialog">
    <Stack className="logoApp">
      <PSTrackerBiancoIcon />
    </Stack>
    <DialogTitle>{getMessageString(intl, WELCOME_TITLE)}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {getMessageString(intl, WELCOME_INFO)}
        <Link to={PATH_FAQ}>faq</Link>
        {")."}
      </DialogContentText>
      <DialogContentText>{getMessageString(intl, WELCOME_INFO_2)}</DialogContentText>
      <DialogContentText sx={{ fontStyle: "italic" }}>{getMessageString(intl, WELCOME_INFO_3)}</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ justifyContent: "center" }}>
      <Button onClick={onEnter}>
        <Stack>
          <ArrowForwardIosOutlinedIcon />
        </Stack>
        <Typography>{getMessageString(intl, ENTER)}</Typography>
      </Button>
    </DialogActions>
  </Dialog>
));
